module.exports = __webpack_public_path__ + "static/img/haveNo.f9262bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/haveNo.png
// module id = zsx3
// module chunks = 1